import clsx from 'clsx'
import { ChevronRightIcon } from 'lucide-react'
import React from 'react'

interface BreadcrumbsItemProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'className'> {
  children: React.ReactNode;
  current?: boolean;
}

export function BreadcrumbsItem ({ children, current, ...props }: BreadcrumbsItemProps) {
  return (
    <li className='flex items-center group/breadcrumb-item'>
      <span className='text-gray-500 group-first/breadcrumb-item:hidden'>
        <ChevronRightIcon aria-hidden size={12} />
      </span>
      <a
        {...props}
        aria-current={current ? 'page' : undefined}
        className={clsx('block p-2 rounded-lg outline outline-2 outline-transparent focus-visible:outline-thatch-500 transition', {
          'text-gray-800 hover:text-gray-800 hover:bg-gray-100 focus-visible:bg-gray-100 cursor-pointer':
            !current,
          'text-thatch-500 hover:text-thatch-500 cursor-default': current,
        })}
      >
        {children}
      </a>
    </li>
  )
}

BreadcrumbsItem.displayName = 'Breadcrumbs.Item'
